import script from "./tab-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab-menu.vue?vue&type=script&setup=true&lang=ts"

import "./tab-menu.vue?vue&type=style&index=0&id=d6213d2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6213d2a"]])

export default __exports__